const $body = $('body'),
    $elem = $('.truedark'),
    classTruedarkVisible = 'show-truedark';

$('[data-toggle="truedark"]').on('click', function () {
    if ($body.hasClass(classTruedarkVisible)) {
        $body.removeClass(classTruedarkVisible);
    } else {
        if (viewport().width > 767) {
            $body.removeClass('show-menu');
            $body.addClass(classTruedarkVisible);
        }
    }
});

$('[data-toggle="theme"]').on('click', function () {
    $body.removeClass(classTruedarkVisible);
});

window.addEventListener('mousemove', (e)=> {
    if ($body.hasClass(classTruedarkVisible)) {
        let xPos = e.clientX,
            xPosPercnt = Math.round(xPos/viewport().width * 100),
            yPos = e.clientY,
            yPosPercnt = Math.round(yPos/viewport().height * 100);

        $elem.css({
            '--pos-x': xPosPercnt + '%',
            '--pos-y': yPosPercnt + '%'
        });
    }
});

// actions on key press
$(document).keyup(function(e) {
    if (e.key === "Escape") {
        $body.removeClass(classTruedarkVisible);
    }
});
